import { updateCompletedAssets } from "../../services/enrollment";
import KnowldgeCheckResult from "./KnowldgeCheckResult";
import QuizBadgeResult from "./QuizBadgeResult";
import CourseBottomNavigation from "./QuizBottomNavigation";

const QuizResultSheet = ({
  isEnrolled,
  courseId,
  linkPrefix,
  nextLesson,
  prevLesson,
  currentQuizzId,
  userEnrollmentId,
  completedAssetIds,
  scoreSheetOverall,
  badgePageUrl,
  educationPageUrl,
  handleReset,
  isKnowledgeCheck,
  questions,
  currentBadge,
  userBadgeYear,
  userBadgeMonth,
}) => {
  const {
    passed,
    passingScore,
    totalPassedQuestions,
    totalQuestions,
    totalScore,
    scoreSheet,
  } = scoreSheetOverall;

  if (passed) {
    const handleUpdateCompletedAssets = async () => {
      const isQuizCompleted = completedAssetIds?.includes(currentQuizzId);

      if (isEnrolled && !isQuizCompleted) {
        await updateCompletedAssets(
          userEnrollmentId,
          completedAssetIds,
          currentQuizzId
        );
      }
    };

    handleUpdateCompletedAssets();
  }

  return (
    <>
      {scoreSheetOverall && !isKnowledgeCheck && (
        <>
          <QuizBadgeResult
            badgePageUrl={badgePageUrl}
            currentBadge={currentBadge}
            educationPageUrl={educationPageUrl}
            handleReset={handleReset}
            passed={passed}
            passingScore={passingScore}
            totalPassedQuestions={totalPassedQuestions}
            totalQuestions={totalQuestions}
            totalScore={totalScore}
            userBadgeMonth={userBadgeMonth}
            userBadgeYear={userBadgeYear}
          />
        </>
      )}

      {isKnowledgeCheck && (
        <>
          <KnowldgeCheckResult
            questions={questions}
            scoreSheet={scoreSheet}
            totalPassedQuestions={totalPassedQuestions}
            totalQuestions={totalQuestions}
          />

          <CourseBottomNavigation
            isEnrolled={isEnrolled}
            courseId={courseId}
            currentQuizzId={currentQuizzId}
            completedAssetIds={completedAssetIds}
            linkPrefix={linkPrefix}
            userEnrollmentId={userEnrollmentId}
            nextLesson={nextLesson}
            prevLesson={prevLesson}
          />
        </>
      )}
    </>
  );
};

export default QuizResultSheet;
